/**
 * Analog soat yuzi (SVG, 100x100). Kunduz -- och yuz, tun -- to'q yuz (Apple kabi), ranglar tokenlardan
 * (index.css: --color-clock-*). Millar CSS animatsiya bilan aylanadi (.clock-hand): React har soniyada chizmaydi,
 * har daqiqada yuz qayta o'rnatiladi va millar aniq vaqtga tekislanadi. Harakat kamaytirilgan bo'lsa -- millar
 * joyida turadi, soniya mili yo'q.
 */
import { cn } from "@/lib/utils";
import { useNow } from "@/lib/useNow";
import { isDaytime, zoneParts } from "./time";

const NUMERALS = Array.from({ length: 12 }, (_, i) => i + 1);

export function AnalogFace({ tz, size, seconds }: { tz: string; size: number; seconds: boolean }) {
  const tick = useNow("minute");
  // Daqiqa boshi emas, aynan hozir: yuz daqiqa o'rtasida ochilsa ham millar to'g'ri turadi
  const now = Date.now();
  const p = zoneParts(new Date(now), tz);
  const sec = p.second + (now % 1000) / 1000;
  const sinceTwelve = (p.hour % 12) * 3600 + p.minute * 60 + sec;
  const numerals = size >= 72;
  return (
    <svg key={tick.getTime()} viewBox="0 0 100 100" width={size} height={size} className={cn("shrink-0", isDaytime(p.hour) ? "clock-day" : "clock-night")} aria-hidden>
      <circle cx="50" cy="50" r="49.5" fill="var(--clock-face)" stroke="var(--color-line)" strokeWidth="0.8" />
      {numerals
        ? NUMERALS.map((n) => {
            const a = (n * Math.PI) / 6;
            return (
              <text key={n} x={50 + 37 * Math.sin(a)} y={50 - 37 * Math.cos(a)} textAnchor="middle" dominantBaseline="central" fontSize="11.5" fontWeight="500" fill="var(--clock-ink)">
                {n}
              </text>
            );
          })
        : NUMERALS.map((n) => (
            <line key={n} x1="50" y1="5" x2="50" y2={n % 3 === 0 ? 12 : 9} stroke="var(--clock-ink)" strokeOpacity={n % 3 === 0 ? 0.9 : 0.45} strokeWidth={n % 3 === 0 ? 2.4 : 1.6} strokeLinecap="round" transform={`rotate(${n * 30} 50 50)`} />
          ))}
      <g className="clock-hand" style={{ animationDuration: "43200s", animationDelay: `-${sinceTwelve}s` }}>
        <line x1="50" y1="50" x2="50" y2="27" stroke="var(--clock-ink)" strokeWidth="4.6" strokeLinecap="round" />
      </g>
      <g className="clock-hand" style={{ animationDuration: "3600s", animationDelay: `-${p.minute * 60 + sec}s` }}>
        <line x1="50" y1="50" x2="50" y2="11" stroke="var(--clock-ink)" strokeWidth="3" strokeLinecap="round" />
      </g>
      <circle cx="50" cy="50" r="3.6" fill="var(--clock-ink)" />
      {seconds && (
        <g className="clock-hand clock-second" style={{ animationDuration: "60s", animationDelay: `-${sec}s` }}>
          <line x1="50" y1="60" x2="50" y2="8" stroke="var(--color-clock-accent)" strokeWidth="1.3" strokeLinecap="round" />
          <circle cx="50" cy="50" r="2.2" fill="var(--color-clock-accent)" />
        </g>
      )}
      <circle cx="50" cy="50" r="0.9" fill="var(--clock-face)" />
    </svg>
  );
}
